import CellBorderColor from './CellBorderColor';

export default CellBorderColor;